module.exports = new __parcel__URL__("machines_shield_battery_level_2.5c1eed27.png").toString();